
<template>
    <div>
        <div class="row">
            <div class="col-md-3">


                <h1>voorbeelden</h1>
                <ul>
                    <li><router-link to="/peguide/vue.aspx/testpage1">router voorbeeld</router-link></li>
                    <li><router-link to="/peguide/vue.aspx/testpage2">todo list</router-link></li>
                    <li><router-link to="/peguide/vue.aspx/testpage3">todolist detail</router-link></li>
                    <li><router-link to="/peguide/vue.aspx/testpage4">security</router-link></li> 
                    <li><router-link to="/peguide/vue.aspx/product">vue api voorbeeld</router-link></li> 
                </ul>
                <h1>Error Tests</h1>
                <div class="testlink" v-on:click="dataerror()">error on data</div>
                <div class="testlink" v-on:click="throwerror()">thrown error</div>                     
            </div>
            <div class="col-md-9">
                <router-view></router-view> 
            </div>
        </div>
       
        
</div>
</template>

<script>
    'use strict'
export default {
        props: {
            enabled: {
                type: Boolean,
                default: false
            },
            filtertitle: {
                type: String,
                default: ''
            }
        },
        data() {
        return {

            }
        },
        methods: {
            dataerror: function () {
                this.filtertitle = false
            },
            throwerror: function () {
                throw new Error('this is not an error')
            },
            translations: function () {

            },
            eventbus: function () {

            },
            routepage3: function () {

            }
        }

}
</script>
